import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {swalConfirm, swalError, swalLoading, swalSuccess} from "../../../helpers/SweetAlertWrapper";
import Page from "../../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../../components/FontAwesomeIcons";
import {UsersModuleEventsAPI} from "../../../api/UsersModuleEvents/UsersModuleEventsAPI";
import {
    getReservationStatusBadgeClassName,
    getReservationStatusLabel,
    RESERVATION_STATUS_ACTIONS,
    RESERVATION_STATUS_PENDING
} from "./UserEventReservationStatus";

export class UserEventReservationDetailPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reservation: props.reservation || {},
            fetching: true,
            changingStatus: false,
        };
        this.defaultValue = "Partecipante";
        this.iconBoxStyle = {
            width: "42px",
            minWidth: "42px",
            height: "42px",
        };
    }

    componentDidMount() {
        this.fetchReservationInfo();
    }

    componentDidUpdate(prevProps) {
        const previousReservation = prevProps.reservation || {};
        const reservation = this.props.reservation || {};
        if (previousReservation.reservation_id !== reservation.reservation_id) {
            this.setState({
                reservation: this.props.reservation || {},
                fetching: true,
            }, this.fetchReservationInfo);
        }
    }


    fetchReservationInfo = _ => {
        const reservation = this.props.reservation || {};
        const reservationId = reservation.reservation_id;
        if (!reservationId) {
            this.setState({fetching: false});
            return;
        }
        UsersModuleEventsAPI.User.getFullReservationInfo(reservationId)
            .then(reservation => {
                this.setState({
                    reservation: reservation || {},
                    fetching: false,
                });
            })
            .catch(error => {
                this.setState({fetching: false});
                swalError(error);
            });
    }


    handleChangeReservationStatus = status => _ => {
        const reservation = this.state.reservation;

        if (reservation.status !== RESERVATION_STATUS_PENDING) {
            return swalError("Per cambiare stato la prenotazione deve essere in stato 'in attesa'");
        }

        swalConfirm("Sei sicuro di voler cambiare lo stato della prenotazione?", "Procedi", "Annulla")
            .then(_ => {
                this.setState({changingStatus: true});
                swalLoading("Aggiornamento stato adesione...");
                UsersModuleEventsAPI.User.changeReservationStatus(reservation.reservation_id, status)
                    .then(message => {
                        const updatedReservation = {
                            ...reservation,
                            status: status,
                            attendance: status,
                        };
                        this.setState({
                            reservation: updatedReservation,
                            changingStatus: false,
                        });
                        if (this.props.onReservationStatusChange) {
                            this.props.onReservationStatusChange(updatedReservation);
                        }
                        swalSuccess(message || "Stato adesione aggiornato.");
                    })
                    .catch(error => {
                        this.setState({changingStatus: false});
                        swalError(error);
                    });
            })
            .catch(_ => null);
    }

    render() {
        const reservation = this.state.reservation || {};
        const participantsInfo = reservation.participants_info || {};
        const participants = reservation.participants || participantsInfo.participants;
        const fullName = reservation.full_name || [reservation.name, reservation.surname].filter(Boolean).join(" ") || this.defaultValue;
        return (
            <Page
                title={"Dettaglio adesione"}
                leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                onLeftIconClick={this.props.onDismiss}
                active={true}
            >
                <div className={"container py-3"}>
                    {
                        this.state.fetching ?
                            <div className={"d-flex align-items-center justify-content-center text-muted py-5"}>
                                <i className="fa fa-spin fa-spinner mr-2"/>
                                Caricamento adesione...
                            </div> :
                            <React.Fragment>
                                <div className={"card border-0 shadow-sm mb-3"}>
                                    <div className={"card-body"}>
                                        <div className={"d-flex align-items-start justify-content-between mb-3"}>
                                            <div className={"d-flex align-items-center"}>
                                                <div
                                                    className={"rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mr-2"}
                                                    style={this.iconBoxStyle}
                                                >
                                                    <FaSolidIcon name={"user"}/>
                                                </div>
                                                <div>
                                                    <h5 className={"font-weight-bold mb-1"}>{fullName}</h5>
                                                    <div className={"small text-muted"}>
                                                        {reservation.email || "Email non disponibile"}
                                                    </div>
                                                </div>
                                            </div>
                                            <span className={`${getReservationStatusBadgeClassName(reservation.status)} px-2 py-1`}>
                                                {getReservationStatusLabel(reservation.status)}
                                            </span>
                                        </div>

                                        <div className={"row border-top pt-3"}>
                                            <div className={"col-6"}>
                                                <div className={"mb-3"}>
                                                    <div className={"small text-muted"}>Partecipanti</div>
                                                    <div className={"font-weight-bold"}>{reservation.participants_number || 1}</div>
                                                </div>
                                            </div>
                                            <div className={"col-6"}>
                                                <div className={"mb-3"}>
                                                    <div className={"small text-muted"}>Creata il</div>
                                                    <div className={"font-weight-bold"}>{moment(reservation.created_at).format("DD/MM/YYYY HH:mm")}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {
                                    reservation.status === RESERVATION_STATUS_PENDING &&
                                    <div className={"card border-0 shadow-sm mb-3"}>
                                        <div className={"card-body"}>
                                            <h6 className={"font-weight-bold mb-3"}>
                                                <FaSolidIcon name={"exchange-alt"} className={"mr-1 text-primary"}/>
                                                Gestione stato
                                            </h6>
                                            <div>
                                                <div className={"small text-muted mb-2"}>Scegli l'esito dell'adesione</div>
                                                {
                                                    RESERVATION_STATUS_ACTIONS.map(action => {
                                                        return (
                                                            <button
                                                                key={action.status}
                                                                type={"button"}
                                                                className={action.className}
                                                                disabled={this.state.changingStatus}
                                                                onClick={this.handleChangeReservationStatus(action.status)}
                                                            >
                                                                <FaSolidIcon name={action.icon} className={"mr-1"}/>
                                                                {action.label}
                                                            </button>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }

                                {
                                    participants.length > 0 &&
                                    <div className={"card border-0 shadow-sm mb-3"}>
                                        <div className={"card-body"}>
                                            <h6 className={"font-weight-bold mb-3"}>
                                                <FaSolidIcon name={"users"} className={"mr-1 text-primary"}/>
                                                Partecipanti
                                            </h6>
                                            <ul className={"list-group"}>
                                                {
                                                    participants.map((participant, index) => (
                                                        <li className={"list-group-item d-flex justify-content-between align-items-start"} key={index}>
                                                            <div>
                                                                <div className={"font-weight-bold"}>{participant.name || (this.defaultValue + " " + (index+1))}</div>
                                                                {
                                                                    participant.has_intolerances &&
                                                                    <div className={"small text-danger mt-1"}>
                                                                        <FaSolidIcon name={"exclamation-triangle"} className={"mr-1"}/>
                                                                        {participant.intolerances || "Intolleranze indicate"}
                                                                    </div>
                                                                }
                                                            </div>
                                                            {
                                                                participant.has_intolerances &&
                                                                <span className={"badge badge-danger"}>Intolleranze</span>
                                                            }
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                }


                                {
                                    reservation.notes &&
                                    <div className={"alert alert-warning mb-3"}>
                                        <div className={"font-weight-bold mb-1"}>
                                            <FaSolidIcon name={"sticky-note"} className={"mr-1"}/>
                                            Note
                                        </div>
                                        <div>{reservation.notes}</div>
                                    </div>
                                }
                            </React.Fragment>
                    }
                </div>
            </Page>
        );
    }
}

UserEventReservationDetailPage.propTypes = {
    reservation: PropTypes.object,
    onDismiss: PropTypes.func,
    onReservationStatusChange: PropTypes.func,
};
